<div [ngClass]="class != null ? class : 'mt-4'">
    <h4 class="mb-0" *ngIf="header != ''">{{ header | translate }}</h4>
    <h4>
        <small *ngIf="subHeader != ''"
            class="text-muted">{{ subHeader | translate}}</small>
    </h4>
</div>
